class NerCountdown extends HTMLElement {
  connectedCallback() {
    const d = parseInt(this.dataset.duration || '300', 10);
    let end = parseInt(sessionStorage.getItem('nerCartEnd') || '0', 10);
    const now = Date.now();
    if (!end || end < now) { end = now + d * 1000; try { sessionStorage.setItem('nerCartEnd', end); } catch (e) {} }
    const tick = () => {
      let r = Math.max(0, Math.round((end - Date.now()) / 1000));
      this.textContent = String(Math.floor(r / 60)).padStart(2, '0') + ':' + String(r % 60).padStart(2, '0');
      if (r <= 0) { end = Date.now() + d * 1000; try { sessionStorage.setItem('nerCartEnd', end); } catch (e) {} }
    };
    tick(); this._t = setInterval(tick, 1000);
  }
  disconnectedCallback() { clearInterval(this._t); }
}
if (!customElements.get('ner-countdown')) customElements.define('ner-countdown', NerCountdown);

// Accordéons Dawn (details/summary) : ouverture / fermeture animées
document.addEventListener('click', function (e) {
  const summary = e.target.closest('.accordion details > summary');
  if (!summary) return;
  const details = summary.parentElement;
  const content = details.querySelector('.accordion__content');
  if (!content || details.dataset.animating) return;
  e.preventDefault();
  details.dataset.animating = '1';
  const cs = getComputedStyle(content);
  const full = { h: content.scrollHeight + 'px', pt: cs.paddingTop, pb: cs.paddingBottom, mt: cs.marginTop, mb: cs.marginBottom };
  const zero = { h: '0px', pt: '0px', pb: '0px', mt: '0px', mb: '0px' };
  const set = (v, withTransition) => {
    content.style.transition = withTransition ? 'height .3s ease, padding .3s ease, margin .3s ease, opacity .3s ease' : 'none';
    content.style.overflow = 'hidden'; content.style.height = v.h; content.style.paddingTop = v.pt; content.style.paddingBottom = v.pb;
    content.style.marginTop = v.mt; content.style.marginBottom = v.mb; content.style.opacity = v === zero ? '0' : '1';
  };
  if (details.open) {
    set(full, false); void content.offsetHeight; set(zero, true);
    setTimeout(() => { details.open = false; content.style.cssText = ''; delete details.dataset.animating; }, 310);
  } else {
    details.open = true; set(zero, false); void content.offsetHeight;
    full.h = content.scrollHeight + 'px'; set(full, true);
    setTimeout(() => { content.style.cssText = ''; delete details.dataset.animating; }, 320);
  }
});

// Bouton « remonter en haut » (mobile)
(function () {
  const btn = document.querySelector('.ner-top');
  if (!btn) return;
  const toggle = () => btn.classList.toggle('is-visible', window.scrollY > 500);
  window.addEventListener('scroll', toggle, { passive: true }); toggle();
  btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
})();

// Vidéos galerie : autoplay muet en boucle, sans contrôles ; Dawn appelle pauseAllMedia() à chaque changement de slide → on relance la slide active
(function () {
  const vids = () => document.querySelectorAll('.product__media-list .ner-autoplay video');
  const prep = (v) => { v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls'); };
  const playActive = () => {
    vids().forEach((v) => {
      prep(v);
      const slide = v.closest('.product__media-item');
      const r = v.getBoundingClientRect();
      const visible = r.width > 0 && r.right > 0 && r.left < innerWidth && r.bottom > 0 && r.top < innerHeight;
      const show = (slide && slide.classList.contains('is-active')) || visible;
      // Chrome ne peint pas une vidéo lancée pendant que sa slide était en display:none → load() quand elle réapparaît
      if (show && v.dataset.nerShown !== '1') {
        // preload="none" : il faut charger, puis attendre canplay avant de lancer (sinon play() est rejeté)
        v.dataset.nerShown = '1';
        v.preload = 'auto';
        v.load();
        v.addEventListener('canplay', function () { v.play().catch(function () {}); }, { once: true });
      }
      if (!show) v.dataset.nerShown = '0';
      if (show) { v.play().catch(function () {}); } else { v.pause(); }
    });
  };
  document.addEventListener('DOMContentLoaded', () => {
    playActive();
    const orig = window.pauseAllMedia;
    if (typeof orig === 'function') {
      window.pauseAllMedia = function () { orig.apply(this, arguments); setTimeout(playActive, 80); setTimeout(playActive, 700); };
    }
    const io = new IntersectionObserver(() => playActive(), { threshold: [0, 0.4, 1] });
    vids().forEach((v) => io.observe(v));
  });
})();

// Cadeaux Huile Anti-Cellulite (Samy, 2026-10-15) : guide dès 2 flacons, brosse dès 3, 1 de chaque au plus,
// jamais sans le palier. Contrôle le panier au chargement et après chaque ajout / modification, retire l'excédent.
(function () {
  var HUILE = 15983670329728, GUIDE = 60115622035840, BROSSE = 60115622003072;
  var f0 = window.fetch.bind(window), timer = null, pending = 0;
  function rafraichir() {
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var items = document.querySelector('cart-drawer-items');
    if (items && typeof items.onCartUpdate === 'function') items.onCartUpdate();
    f0('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var b = document.getElementById('cart-icon-bubble'), h = s && s['cart-icon-bubble'];
      if (!b || !h) return;
      var src = new DOMParser().parseFromString(h, 'text/html').querySelector('.shopify-section');
      b.innerHTML = src ? src.innerHTML : h;
    }).catch(function () {});
  }
  function verifier() {
    f0('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var n = 0;
      cart.items.forEach(function (i) { if (i.product_id === HUILE) n += i.quantity; });
      var droit = {}; droit[GUIDE] = n >= 2 ? 1 : 0; droit[BROSSE] = n >= 3 ? 1 : 0;
      var updates = {}, change = false, vu = {};
      cart.items.forEach(function (i) {
        if (!(i.variant_id in droit)) return;
        var q = Math.min(i.quantity, vu[i.variant_id] ? 0 : droit[i.variant_id]);
        if (q > 0) vu[i.variant_id] = true;
        if (q !== i.quantity) { updates[i.key] = q; change = true; }
      });
      if (!change) return;
      return f0('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(rafraichir);
    }).catch(function () {});
  }
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!/\/cart\/(add|change|update|clear)/.test(url)) return f0.apply(window, arguments);
    clearTimeout(timer); pending++;
    return f0.apply(window, arguments).finally(function () {
      pending--;
      if (!pending) timer = setTimeout(verifier, 1200);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', verifier); else verifier();
  window.addEventListener('pageshow', function (e) { if (e.persisted) verifier(); });
})();
